export interface CheckoutSettingsModel {
  fieldName: string;
  defaultValue: any;
  displayName?: string;
  skipCounterChanges?: boolean;
}

export const CheckoutSettingsConfig: CheckoutSettingsModel[] = [
  {
    fieldName: 'isTestMode',
    defaultValue: false,
  },
  {
    fieldName: 'enableOptimization',
    defaultValue: false,
  },
  {
    fieldName: 'enableIncreaseRatesPercentage',
    defaultValue: false,
  },
  {
    fieldName: 'increaseRatesPercentage',
    defaultValue: 20,
  },
  {
    fieldName: 'runTestVariantsTogether',
    defaultValue: false,
  },
  {
    fieldName: 'percentTestVariantTraffic',
    defaultValue: 50,
  },
  {
    fieldName: 'scriptTagEnabled',
    defaultValue: false,
  },
  {
    fieldName: 'preventMultipleShippingCost',
    defaultValue: false,
  },
  {
    fieldName: 'subTotalIncludesDiscounts',
    defaultValue: false,
  },
  {
    fieldName: 'checkoutScriptTagManuallySet',
    defaultValue: false,
    skipCounterChanges: true,
  },
  {
    fieldName: 'enableDeliveryCustomization',
    defaultValue: false,
  },
  {
    fieldName: 'pluginsScriptTagEnabled',
    defaultValue: false,
  },
  {
    fieldName: 'enableCheckoutPrioritization',
    defaultValue: false,
  },
  {
    fieldName: 'hasShippingMethodDiscount',
    defaultValue: false,
  },
  {
    fieldName: 'shippingMethodDiscounts',
    defaultValue: [],
  },
];
